import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import {NotificationDetailComponent} from "./notification-detail.component";

const routes: Routes = [
  {
    path: '',
    component: NotificationDetailComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NotificationDetailRoutingModule {}
